import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=12b4d020&scoped=true"
import script from "../js/Clients?vue&type=script&lang=js&external"
export * from "../js/Clients?vue&type=script&lang=js&external"
import style0 from "./ClientsView.vue?vue&type=style&index=0&id=12b4d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4d020",
  null
  
)

export default component.exports